exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".stripe-checkout .card-element {\n  margin-top: 40px;\n  margin-bottom: 20px;\n  border: 1px solid #eee;\n  padding: 15px; }\n\n.stripe-checkout .btn-checkout {\n  width: 150px; }\n", ""]);

// exports
